import { render } from "./configure_exam.vue?vue&type=template&id=3e24830c&scoped=true"
import script from "./configure_exam.js?vue&type=script&lang=js"
export * from "./configure_exam.js?vue&type=script&lang=js"

import "./configure_exam.vue?vue&type=style&index=0&id=3e24830c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e24830c"]])

export default __exports__